import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { HiOutlineMail, HiArrowLeft } from 'react-icons/hi';
import { authAPI, systemAPI } from '../services/api';
import { getErrorMessage } from '../utils/errorHandler';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [version, setVersion] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await systemAPI.getVersion();
        setVersion(response.data.version);
      } catch (error) {
        setVersion('1.4.1');
      }
    };

    fetchVersion();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error(t('auth.enterEmail'));
      return;
    }

    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setEmailSent(true);
      toast.success(t('auth.emailSentIfRegistered'));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Tela de sucesso após enviar email
  if (emailSent) {
    return (
      <div className="auth-page">
        <div className="auth-box">
          <div className="auth-header">
            <h1>My Series</h1>
            <p>{t('auth.forgotPasswordTitle')}</p>
          </div>

          <div className="auth-success" style={{ textAlign: 'center', padding: '32px 24px' }}>
            <div 
              className="auth-icon-large" 
              style={{ 
                width: '64px', 
                height: '64px', 
                borderRadius: '50%', 
                background: 'var(--success-bg)', 
                color: 'var(--success)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
                margin: '0 auto 16px'
              }}
            >
              <HiOutlineMail />
            </div>
            <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '8px' }}>
              {t('auth.emailSent')}
            </h3>
            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: '24px' }}>
              {t('auth.checkEmailInstructions', { email })}
            </p>

            <button
              className="btn btn-primary"
              onClick={() => navigate('/login')}
              style={{ width: '100%' }}
            >
              {t('auth.backToLogin')}
            </button>
          </div>

          <div className="auth-footer" style={{ textAlign: 'center', marginTop: '24px' }}>
            <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
              {t('auth.copyright')}
            </p>
            <p style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
              {t('common.version')} {version}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-header">
          <Link 
            to="/login" 
            className="auth-back-link"
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '4px',
              color: 'var(--primary)',
              textDecoration: 'none',
              fontSize: '14px',
              marginBottom: '16px'
            }}
          >
            <HiArrowLeft /> {t('auth.backToLogin')}
          </Link>
          <h1>My Series</h1>
          <p>{t('auth.forgotPasswordTitle')}</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <p style={{ marginBottom: '16px', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            {t('auth.forgotPasswordDescription')}
          </p>

          <div className="form-group">
            <label className="form-label">{t('common.email')}</label>
            <div style={{ position: 'relative' }}>
              <HiOutlineMail
                style={{
                  position: 'absolute',
                  left: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'var(--text-muted)',
                }}
              />
              <input
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('auth.enterRegisteredEmail')}
                style={{ paddingLeft: '48px' }}
                required
                autoFocus
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', marginTop: '8px' }}
          >
            {loading ? t('auth.sending') : t('auth.sendInstructions')}
          </button>
        </form>

        <div className="auth-footer" style={{ textAlign: 'center', marginTop: '24px' }}>
          <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
            {t('auth.copyright')}
          </p>
          <p style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
            {t('common.version')} {version}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
